__turbopack_context__.v({
  "body": "BoardSectionItemShortnews-module-scss-module__HLDNCa__body",
  "footer": "BoardSectionItemShortnews-module-scss-module__HLDNCa__footer",
  "header": "BoardSectionItemShortnews-module-scss-module__HLDNCa__header",
  "list": "BoardSectionItemShortnews-module-scss-module__HLDNCa__list",
  "wrapper": "BoardSectionItemShortnews-module-scss-module__HLDNCa__wrapper",
});
